// GeneralErrorToastr.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { EMPTY_OBJECT, NULL_FUNCTION } from '../resource/defaults.js';
import DefaultConfirmation from './DefaultConfirmation.jsx';
import FadeOutToBottom from '../style/FadeOutToBottom.js';
import FadeInFromBottom from '../style/FadeInFromBottom.js';
import media from '../style/media.js';

export class GeneralErrorToastr extends React.PureComponent {
  state = { isServer: true, show: true };
  nextTick = null;

  componentDidMount() {
    this.nextTick = setTimeout(() => this.setState({ isServer: false }), 0);
  }

  componentWillUnmount() {
    clearTimeout(this.nextTick);
  }

  render() {
    const { isServer, show } = this.state;
    const { durationSec, errorObject, t, retry } = this.props;
    const isNetworkingIssue = errorObject?.name === 'ChunkLoadError';

    if (isServer) {
      return <div className="error-placeholder" />;
    }

    if (!show) {
      return null;
    }

    return (
      <AnimatedWrapper $durationSec={durationSec} $show={show}>
        <DefaultConfirmation
          type="error"
          title={t(
            isNetworkingIssue ? 'retry_failed_reason' : 'something_went_wrong',
            {
              ns: TranslationNamespace.NOTIFICATION,
            }
          )}
          primaryButtonText={t('retry', {
            ns: TranslationNamespace.DEFAULT,
          })}
          onPrimaryButtonClick={retry}
          secondaryButtonText={t('general_cancel', {
            ns: TranslationNamespace.GENERAL,
          })}
          onSecondaryButtonClick={() => this.setState({ show: false })}
        />
      </AnimatedWrapper>
    );
  }
}

GeneralErrorToastr.propTypes = {
  errorObject: PropTypes.object,
  durationSec: PropTypes.number,
  t: PropTypes.func.isRequired,
  retry: PropTypes.func,
};

GeneralErrorToastr.defaultProps = {
  errorObject: EMPTY_OBJECT,
  durationSec: 0.6,
  retry: NULL_FUNCTION,
};

const AnimatedWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  margin: 0 12px;
  z-index: 199;

  ${media.tablet`
    margin: 0 auto;
  `}

  ${media.mobile`
    margin: 0 12px;
  `}

  animation: ${({ $durationSec }) => $durationSec}s forwards
    ${({ $show }) => ($show ? FadeInFromBottom : FadeOutToBottom)};
`;

export default withTranslation()(GeneralErrorToastr);
